import { render, staticRenderFns } from "./float_ad.vue?vue&type=template&id=079747a8&scoped=true&"
import script from "./float_ad.vue?vue&type=script&lang=js&"
export * from "./float_ad.vue?vue&type=script&lang=js&"
import style0 from "./float_ad.vue?vue&type=style&index=0&id=079747a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079747a8",
  null
  
)

export default component.exports